<template>
  <el-card :class="`quotes-detail-response-resume ${value.state.toLowerCase()}`"
           shadow="never">
    <div class="line">
      <div>
        <strong>{{ value.carrierName }}</strong>
      </div>
      <el-tag :type="value.state==='SUBMITTED' || value.state==='WON' ? 'success' : 'info'"
              effect="dark"
              size="mini"
              v-if="value.bidAmount">
        {{ value.bidAmount | currency({ currency: value.currency, minimumFractionDigits: 0 }) }}
      </el-tag>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'QuotesDetailResponseResume',
  props: {
    value: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.quotes-detail-response-resume {
  &:hover,
  &:active {
    background-color: #EBEEF5;
    cursor: pointer;
  }

  &.lost,
  &.open {
    color: #C0C4CC;
    &:hover,
    &:active {
      background-color: #FFFFFF;
      cursor: not-allowed;
    }
  }

  &.won {
    color: #FFFFFF;
    background-color: #67C245;
    border-color: #67C245;
  }

  .line {
    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 13px;
  }
}
</style>
